window.addEventListener('DOMContentLoaded', () => {
  let quickViewModal = document.querySelector('#PopupModal-quickview');
  let quickViewTriggers = document.querySelectorAll('.article-body [href*="/products/"]');
  quickViewTriggers?.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      fetch(`${btn.href.split('?')[0]}?view=quick-view`)
      .then(res => res.text())
      .then(data => {
        let modalContainer = quickViewModal.querySelector('.modal-body');
        modalContainer.innerHTML = data;
        let scripts = modalContainer.querySelectorAll('script');
        scripts.forEach(script => {
          let newScript = document.createElement('script');
          newScript.type = script.type || 'text/javascript';
          if (script.src) {
            newScript.src = script.src;
            newScript.async = false;
          } else {
            const wrappedScript = `(function() { ${script.textContent} })();`;
            newScript.textContent = wrappedScript;
          }
          modalContainer?.appendChild(newScript);
        });
        
        yotpoWidgetsContainer?.initWidgets()
        quickViewModal?.show();
      })
    })
  })
})

window.addEventListener('DOMContentLoaded', () => {
    let button = document.querySelector(".article-product-wrap button");

    if (button != null) {
      button.addEventListener('click', () => {
          let targetElement = document.getElementById("article-metafield-product");
          if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth' });
          }
      });
    }
});

